// AboutUs.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import styles from './AboutUs.module.css';

import Header from '../Header/Header';
import abstractSvg from '../Assets/abstract.svg';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
    const navigate = useNavigate();

    const handleExploreClick = () => {
        navigate('/hookb'); 
    };

    return (
        <div>
            <Helmet>
                <title>About Us | Contranorm Media & Production&nbsp;&trade;</title>
                <meta 
                    name="description" 
                    content="Document preparation, digital content creation, project-based research, and personalized support for students, entrepreneurs, and employees." 
                />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://contranormdigital.com/about-us" />
            </Helmet>

            <Header />
           
         
            <div className={styles['about-us-container']}>
                <div className={styles['about-us-text']}>
                    <h1 className={styles['text']}>Redefining What’s Possible</h1>
                    <p>
                        At Contranorm Media & Production™, we specialize in turning obstacles into opportunities. From adaptive SAT prep and continuing education to professional-grade advocacy and document preparation, we help you master the systems that shape your success.
                    </p>
                            
                </div>
                <div className={styles['about-us-image-container']}>
                    <div className={styles['about-us-image']}>
                        <img src={abstractSvg} alt="Abstract" />
                    </div>
                </div>
                <div className={styles['explore-wrapper']}>
                    <button className={styles['explore']} onClick={handleExploreClick}>
                        <span>Explore</span>
                    </button>

                </div>
                

               
            </div>
        </div>
    );
};

export default AboutUs;
